import { ErrorStateMatcher } from '@angular/material/core';
import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { Signal } from '@angular/core';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  constructor(private submitted: Signal<boolean>) {}
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return (control?.invalid && this.submitted()) ?? false;
  }
}
